<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="betting-record-page">
            <div class="common-header">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit"> {{ $t('mine.Rebaterecord') }} </font></font
              >
            </div>
            <div class="search-options-wrapper">
              <div id="betting-create-selector">
                <div class="common-search-item">
                  <div class="common-search-item-name">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.platform') }} </font></font
                    >
                  </div>
                  <div class="common-search-item-content">
                    <el-select size="mini" v-model="api_type" :placeholder="$t('mine.platform')" @change="changApiType">
                      <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div id="betting-create-selector">
                <div class="common-search-item">
                  <div class="common-search-item-name">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Timerange') }} </font></font
                    >
                  </div>
                  <div class="common-search-item-content">
                    <div>
                      <el-radio-group v-model="date" size="mini" @change="changeDate">
                        <el-radio-button :label="1">{{ $t('mine.today') }}</el-radio-button>
                        <el-radio-button :label="2">{{ $t('mine.week') }}</el-radio-button>
                        <el-radio-button :label="3">{{ $t('mine.month') }}</el-radio-button>
                        <el-radio-button :label="4">{{ $t('mine.onemonth') }}</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="betting-record-list-wrapper">
              <div class="common-list-wrapper">
                <div class="list-total-count" style="padding-left: 42px; box-sizing: border-box">
                  <div class="list-total-count-title">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Rebatestatus') }} </font></font
                    >
                  </div>
                  <ul class="data-list">
                    <li style="margin-left: 15px">
                      <span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Accumulatedpayment') }} ：</font></font
                        ></span
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">￥{{ jisuan }}</font></font
                      >
                    </li>
                    <li>
                      <span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit">{{ $t('mine.Unpaidsdf') }}</font></font
                        ></span
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">￥{{ nojisuan }}</font></font
                      >
                    </li>
                    <li>
                      <button type="button" class="el-button el-button--primary" @click="lingqu">
                        <!----><!----><span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('mine.Receive') }}</font></font
                          ></span
                        >
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="list-wrapper">
              <div class="ant-table-wrapper">
                <div class="ant-spin-nested-loading">
                  <div class="ant-spin-container">
                    <div class="ant-table">
                      <div class="ant-table-container">
                        <div class="ant-table-content">
                          <table style="table-layout: auto">
                            <colgroup></colgroup>
                            <thead class="ant-table-thead">
                              <tr>
                                <th class="ant-table-cell col-api-type-id">{{ $t('mine.Gamename') }}</th>
                                <th class="ant-table-cell col-single-amount">{{ $t('mine.Rebateamount') }}</th>
                                <th class="ant-table-cell col-effective-trade-amount">{{ $t('mine.Status') }}</th>
                                <th class="ant-table-cell col-profit-amount">{{ $t('mine.Rebatetime') }}</th>
                                <th class="ant-table-cell col-profit-amount">{{ $t('mine.Collectiontime') }}</th>
                              </tr>
                            </thead>
                            <tbody class="ant-table-tbody" v-if="fanshuiList.length > 0">
                              <tr class="ant-table-placeholder" v-for="(item, index) in fanshuiList" :key="index">
                                <td>{{ item.gamename }}</td>
                                <td>{{ item.money }}</td>
                                <td>{{ item.state == 0 ? $t('mine.Unpaidsdf') : $t('mine.Received') }}</td>
                                <td>{{ item.created_at }}</td>
                                <td>{{ item.state == 0 ? $t('mine.Not') : item.updated_at }}</td>
                              </tr>
                            </tbody>
                            <tbody class="ant-table-tbody" v-if="fanshuiList.length == 0">
                              <tr class="ant-table-placeholder">
                                <td colspan="8" class="ant-table-cell">
                                  <div class="empty-content">
                                    <span
                                      ><font style="vertical-align: inherit"
                                        ><font style="vertical-align: inherit">{{ $t('mine.Nodata') }}</font></font
                                      ></span
                                    >
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <el-pagination v-if="fanshuishowData.total" style="margin: 20px 0 0px 120px" @current-change="getfanshui" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="fanshuishowData.total"></el-pagination>
                          <div style="height: 30px"></div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'fanshui',
  data() {
    return {
      date: 4,
      fanshuiList: [],
      fanshuishowData: {},
      jisuan: 0,
      nojisuan: 0,
      page: 1,
      dogameLis: [],
      api_type: '',
    };
  },
  created() {
    let that = this;
    that.getdogame();

    that.getfanshui();
  },
  methods: {
    changApiType() {
      let that = this;
      that.page = 1;
      that.getfanshui();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: that.$t('mine.platforms'), platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getfanshui();
    },
    // 获取返水记录
    getfanshui() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
        type: '',
      };
      that.$apiFun
        .post('/api/getfanshui', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.fanshuiList = res.data.list.data;
            that.fanshuishowData = res.data.list;
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, that.$t('mine.Thereclaim'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          console.log(res);
          that.$parent.getUserInfo();
          that.$parent.showTost(1, res.message);
          that.getfanshui();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/betting.css';
.spinner {
  width: 1em;
  height: 1em;
  position: relative;
  font-size: 200px;
  margin: 0 auto;
}

.spinner .line {
  width: 0.15em;
  height: 5px;
  border-radius: 5px;
  background-color: #b5b5b6;
  animation: spinner-line 1s infinite;
  position: absolute;
  right: 0;
  bottom: -0.1em;
}

.spinner svg {
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  top: -0.1em;
  left: -0.1em;
  animation: spinner-jerry-fish 1s infinite;
  z-index: 1;
}

.spinner p {
  width: 100%;
  position: absolute;
  bottom: calc(-0.1em - 40px);
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin: unset;
  display: flex;
  justify-content: center;
}

.spinner p span {
  font-size: 14px;
  color: #c9caca;
}

.spinner .circle {
  width: 1em;
  height: 1em;
  border-radius: 50%;
}

.spinner .circle i {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  animation: spinner-circle-clipper linear 1s infinite;
}

.spinner .circle i:after {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  content: '';
  animation: spinner-circle 1s linear infinite;
  border-radius: 50%;
  box-shadow: inset 0 0 0 4px #c9caca;
}

@keyframes spinner-circle-clipper {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(60deg);
  }
  50% {
    transform: rotate(60deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-circle {
  0% {
    transform: rotate(-180deg);
  }
  5% {
    transform: rotate(-170deg);
  }
  30% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-jerry-fish {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-line {
  0% {
    opacity: 0;
    right: 0;
  }
  5% {
    opacity: 0.2;
  }
  10% {
    opacity: 0.4;
  }
  15% {
    opacity: 0.6;
  }
  20% {
    opacity: 0.8;
  }
  25% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  35% {
    opacity: 0.8;
  }
  40% {
    opacity: 0.6;
  }
  45% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.3;
  }
  55% {
    opacity: 0.2;
  }
  60% {
    opacity: 0.1;
  }
  65% {
    opacity: 0;
    right: calc(100% - 0.25em);
  }
  100% {
    opacity: 0;
    right: 0;
  }
}
.active {
  color: #fff !important;
}
.ant-table-thead > tr > th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/fanshui.vue